import { useState } from "react";
import { RefreshCw } from "lucide-react";
import { cn } from "@/lib/utils";

export function RefreshButton({ onRefreshed }: { onRefreshed: () => void }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function refresh() {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch("/api/stripe/sync", {
        method: "POST",
        credentials: "include",
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error ?? "Sync failed");
      onRefreshed();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Sync failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex items-center gap-2">
      {error && <span className="text-xs text-destructive">{error}</span>}
      <button
        type="button"
        onClick={refresh}
        disabled={loading}
        className="flex items-center gap-2 rounded-md border bg-white px-3 py-1.5 text-sm font-medium shadow-sm transition hover:bg-slate-50 disabled:opacity-60"
      >
        <RefreshCw className={cn("h-4 w-4", loading && "animate-spin")} />
        {loading ? "Refreshing..." : "Refresh"}
      </button>
    </div>
  );
}
